import { GruposListSearchComponent } from './GruposListSearchComponent'
import { GruposListToolbar } from './GruposListToolbar'

export const GruposListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <GruposListSearchComponent actions={<GruposListToolbar />} />
    </div>
  )
}
